import {TableCell } from "@braze/beacon-core"
import { CampaignDrawer } from "./CampaignDrawer"
import { CampaignObject } from "../../types/APITypes";


type CampaignTableRowProps = {
    campaign: CampaignObject;
};


export const CampaignTableRow = ({campaign} : CampaignTableRowProps) => {
        
    return (
        <>
                <TableCell>
                    <CampaignDrawer campaign={campaign}/>
                </TableCell>
                <TableCell>
                    {campaign.submission_date}
                </TableCell>
                <TableCell style={{borderBottom:"0px"}}>
                    {campaign.approval_status}
                </TableCell>
        </>
        
    )
}